import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';
export default (function (params) {
  const { isRequestSuccessed, data, exec, isLoading } = useRequest({
    url: '',
    name: 'deviceShutdownAnalysisGet',
    method: 'GET',
  });
  useEffect(() => {
    if (params) {
      let url = `/api/device/shutdown/analysis`;
      Object.keys(params).forEach((key, index) => {
        if (index === 0) {
          url += '?';
        } else {
          url += '&';
        }
        url += `${key}=${params[key]}`;
      });
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);
  return [isRequestSuccessed, data || {}, exec, isLoading];
});
